var storefrontApp = angular.module('storefrontApp');

storefrontApp.service('reviewService', ['$http', function ($http) {
    return {
        getReviews: function () {
            return $http.get('storefrontapi/allreviews');
        },
        getReviewsByUser: function (userId) {
            return $http.get('storefrontapi/getreviewsbyuserid?userId=' + userId);
        },
        getReviewsByOrderLineId: function (userId, orderId, lineId) {
            return $http.get('storefrontapi/reviewsByOrderLineId?userId=' + userId + '?orderId=' + orderId + '?lineItemId=' + lineId);
        },
       insertReview: function (review, categories, file) {
            var formdata = new FormData();
            formdata.append('review', angular.toJson(review));
            formdata.append("file", file);
            formdata.append("categories", categories);
            return $http.post('storefrontapi/insertuserreview', formdata, {
                headers: { 'Content-Type': undefined },
            });

        },
        updateReview: function (review, categories, file) {
            var formdata = new FormData();
            formdata.append('review', angular.toJson(review));
            formdata.append("file", file);
            formdata.append("categories", categories);
            return $http.post('storefrontapi/updateuserreview', formdata, {
                headers: { 'Content-Type': undefined },
            });

        },
        getReviewsByOrder: function (orderId,itemId,isReviewUpdate) {
            return $http.get('storefrontapi/customerreviewsbyorderid?oid=' + orderId + '&itemId=' + itemId + '&isEdit=' + isReviewUpdate);
        },
        getReviewsCategories: function () {
            return $http.get('storefrontapi/getreviewscategories');
        },
        getCustomerReviewSettings: function () {
            return $http.get('storefrontapi/reviewsettings');
        }
    }
}]);
